import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import classNames from 'classnames';
import get from 'lodash.get';
import React, { useEffect } from 'react';
import { Anchor } from '@mirohq-internal/website-ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var toggleOneTrust = function toggleOneTrust(event) {
  var toggleInfoDisplay = get(window, 'OneTrust.ToggleInfoDisplay');

  if (!toggleInfoDisplay) {
    return;
  }

  event.preventDefault();
  toggleInfoDisplay === null || toggleInfoDisplay === void 0 ? void 0 : toggleInfoDisplay();
};

export var LegalHub = function LegalHub(_ref) {
  var legalHubLinks = _ref.legalHubLinks;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isInUS = _React$useState2[0],
      setIsInUS = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  useEffect(function () {
    var intervalOneTrust = setInterval(function () {
      var _window$OneTrust;

      if (typeof ((_window$OneTrust = window.OneTrust) === null || _window$OneTrust === void 0 ? void 0 : _window$OneTrust.getGeolocationData) === 'function') {
        clearInterval(intervalOneTrust);
        var geoLocationData = window.OneTrust.getGeolocationData();
        setIsInUS("".concat(geoLocationData.country).toUpperCase() === 'US');
        setLoading(false);
      }
    }, 100);
    return function () {
      clearInterval(intervalOneTrust);
    };
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: legalHubLinks.map(function (link) {
      if (!isInUS && link.href.includes('ccpa')) {
        return null;
      }

      return /*#__PURE__*/_jsx(Anchor, {
        href: link.href,
        className: classNames('fade fade-in text-tertiary', {
          show: !loading
        }),
        onClick: link !== null && link !== void 0 && link.withOneTrust ? toggleOneTrust : undefined,
        children: /*#__PURE__*/_jsx("span", {
          className: "d-block text-wrap text-center",
          children: link.title
        })
      }, link.href);
    })
  });
};